<template>
    <div class="search_design" :class="{ android: android }">
        <div class="search_bar">
            <div class="input_box">
                <input class="search_input" :class="{ on: value }" type="text" v-model="value" />
                <span class="clear_btn" v-show="value" @click="clear"></span>
            </div>
            <span class="cancel_btn" @click="cancel">取消</span>
        </div>
        <div class="search_list" @touchstart="hideKeyboard">
            <ul v-for="(item, index) in list" :key="index">
                <li
                    v-for="(item2, index2) in item"
                    :key="index2"
                    :style="{ height: item2.height + 'px', width: item2.width + 'px' }"
                >
                    <router-link :to="item2.link">
                        <img :src="item2.src" />
                        <div class="img_info">
                            <div class="img_info_center">
                                <p class="desgin_name">{{ item2.name }}</p>
                            </div>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="no_match" v-show="noMatch">未找到满足条件的设计图</div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            value: "",
            noMatch: false,
            list: []
        }
    },
    computed: {
        android() {
            return window.system === "android"
        }
    },
    watch: {
        value: function(newVal, oldVal) {
            this.debounceSearch(newVal)
        }
    },
    created() {
        this.debounceSearch = _debounce(this.search, 300)
    },
    mounted() {
        this.inputFocus()
    },
    methods: {
        inputFocus() {
            document.querySelector(".search_input").focus()
        },
        hideKeyboard() {
            if (isWebview) {
                Keyboard.hide()
            }
        },
        clear() {
            this.value = ""
        },
        cancel() {
            this.$router.go(-1)
        },
        async search(value) {
            if (!value && value !== 0) {
                this.list = []
                this.noMatch = false
            } else {
                let team_id = localStorage.teamId
                let project_id = this.$route.query.project_id
                this.$root.eventBus.$emit("showLoading")
                let res = await API.project.searchImages(team_id, project_id, value)
                if (res) {
                    let data = res.data
                    let arr = []
                    data.result.forEach(ele => {
                        if (ele.type != "card") {
                            arr.push({
                                id: ele.id,
                                name: ele.name,
                                src: ele.url,
                                height: ele.height,
                                width: ele.width,
                                link: {
                                    name: "design",
                                    query: {
                                        project_id: project_id,
                                        project_name: this.$route.query.project_name,
                                        image_id: ele.id
                                    }
                                }
                            })
                        }
                    })

                    if (!arr.length) {
                        this.noMatch = true
                    } else {
                        this.noMatch = false
                    }

                    this.list = this.toWaterfall(arr)

                    this.$root.eventBus.$emit("hideLoading")
                }
            }
        },
        toWaterfall(data) {
            let json1 = { num: 0, arr: [] },
                json2 = { num: 0, arr: [] }

            let width = (document.querySelector(".search_list").offsetWidth - 30) / 2

            data.forEach(ele => {
                let height = (Number(width) / Number(ele.width)) * Number(ele.height)
                ele.height = height + 4 * parseInt(window.rem)
                ele.width = width

                let num = 2

                ele.src = window.mtd.handleImg(ele.src,{
                    ali:this.$root.isSupportWebp
                        ?`?x-oss-process=image/resize,m_lfit,h_${Math.ceil(ele.height) * num},w_${Math.ceil(ele.width) * num}/format,webp`
                        :`?x-oss-process=image/resize,m_lfit,h_${Math.ceil(ele.height) * num},w_${Math.ceil(ele.width) * num}`,
                    qiniu:`?imageMogr2/w/${Math.ceil(ele.width) * num}/h/${Math.ceil(ele.height) * num}`
                })

                if (json1.num > json2.num) {
                    json2.arr.push(ele)
                    json2.num += ele.height
                } else {
                    json1.arr.push(ele)
                    json1.num += ele.height
                }
            })

            return [json1.arr, json2.arr]
        }
    }
}
</script>

<style lang="scss" scoped>
.search_design {
    &.android {
        padding-top: 3.35rem;
        .search_bar {
            padding-top: 1.6rem;
        }
    }
    height: 100%;
    box-sizing: border-box;
    padding-top: 2.35rem;
    padding-top: calc(constant(safe-area-inset-top) + 2.35rem);
    padding-top: calc(env(safe-area-inset-top) + 2.35rem);
    .search_bar {
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        padding-top: 1.5rem; //ios_top
        padding-top: calc(constant(safe-area-inset-top) + 0.4rem);
        padding-top: calc(env(safe-area-inset-top) + 0.4rem);
        padding-bottom: 0.4rem;
        z-index: 111;
        height: 1.25rem;
        background: #edeff1;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        .input_box {
            position: relative;
            float: left;
            margin-left: 0.5rem;
        }
        .search_input {
            height: 1.25rem;
            border-radius: 1.25rem;
            background: rgba(255, 255, 255, 0.6) 0.4rem center / 0.61rem no-repeat;
            // background: rgba(255, 255, 255, 0.6) url("~@/assets/imgs/search_icon.png") 0.4rem center / 0.61rem no-repeat;
            width: 15.9rem;
            padding: 0 0.5rem;
            box-sizing: border-box;
            float: left;
            &.on {
                background: rgba(255, 255, 255, 0.6);
            }
        }
        .cancel_btn {
            padding-right: 0.75rem;
            float: right;
            height: 1.25rem;
            line-height: 1.25rem;
            font-size: 0.65rem;
            color: #222222;
        }
        .clear_btn {
            position: absolute;
            right: 0.5rem;
            top: 0.3rem;
            width: 0.65rem;
            height: 0.65rem;
            background: url("~@/assets/imgs/clear_close.png") left center / 100% no-repeat;
        }
    }
    .search_list {
        // height: 100%;
        padding: 0 10px 20px 10px;
        box-sizing: border-box;
        // display:grid;
        // grid-gap:10px;
        // grid-template-columns:1fr 1fr;
        overflow-y: auto;
        height: 100%;
        box-sizing: border-box;

        ul {
            width: calc(50% - 5px);
            &:nth-child(1) {
                float: left;
            }
            &:nth-child(2) {
                float: right;
            }

            li {
                box-sizing: border-box;
                background: white;
                margin-top: 10px;
                box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                overflow: hidden;
                img {
                    display: block;
                    width: 100%;
                }
                .img_info {
                    width: 100%;
                    background: white;
                    height: 4rem;
                    overflow: hidden;
                    display: table;
                    .img_info_center {
                        display: table-cell;
                        vertical-align: middle;
                    }
                    // display:grid;
                    // align-items:center;
                }
                .desgin_name {
                    width: 100%;
                    font-size: 0.7rem;
                    color: #222222;
                    text-align: center;
                    padding: 0 0.5rem;
                    display: -webkit-box;
                    text-overflow: ellipsis;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    box-sizing: border-box;
                    max-height: 3rem;
                    word-break: break-all;
                }
            }
        }
    }
    .no_match {
        font-size: 0.7rem;
        color: rgba(136, 136, 136, 1);
        text-align: center;
        position: absolute;
        left: 0;
        top: 40%;
        width: 100%;
        text-align: center;
    }
}
</style>
